var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',_vm._l((_vm.bulletins),function(ref){
var id = ref.id;
var title = ref.title;
var content = ref.content;
return _c('v-col',{key:id,attrs:{"cols":12,"md":4}},[_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(title))]),_c('v-card-text',{domProps:{"innerHTML":_vm._s(content)}})],1)],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }